// Support both REACT_APP_ and VITE_ prefixes during transition
// In Vite, use import.meta.env instead of process.env
export const env = import.meta.env.VITE_ENV || import.meta.env.REACT_APP_ENV;
export const baseUrl = import.meta.env.VITE_BACKEND_BASE_URL || import.meta.env.REACT_APP_BACKEND_BASE_URL;
export const idValidationUrl = import.meta.env.VITE_USER_VERIFY_URL || import.meta.env.REACT_APP_USER_VERIFY_URL;
export const oktaIssuer = import.meta.env.VITE_OKTA_ISSUER || import.meta.env.REACT_APP_OKTA_ISSUER;
export const oktaClientId = import.meta.env.VITE_OKTA_CLIENT_ID || import.meta.env.REACT_APP_OKTA_CLIENT_ID;
export const retailGidGroups = (import.meta.env.VITE_RETAIL_GID_GROUPS || import.meta.env.REACT_APP_RETAIL_GID_GROUPS)
  ? (import.meta.env.VITE_RETAIL_GID_GROUPS || import.meta.env.REACT_APP_RETAIL_GID_GROUPS).split(",")
  : [];
